/*!
   Copyright 2019 Ron Buckton

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

       http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.
*/
/* @internal */ declare const Tag: unique symbol;
/* @internal */ export type Tag<Tag extends string> = { [Tag]: Tag };
/* @internal */ export type EPOCH_DAYS = number & Tag<"EPOCH_DAYS">;
/* @internal */ export type NANOS_OF_DAY = bigint & Tag<"NANOS_OF_DAY">;
/* @internal */ export type NANOS_OF_EPOCH = bigint & Tag<"NANOS_OF_EPOCH">;
